import React from 'react';
import styled from 'styled-components/macro';
import { PbiFilterSystemsProps } from './PbiFilterSystemsContainer';
import PbiFilterSystemsMobile from './PbiFilterSystemsMobile';
import PbiFilterSystemsDesktop from './PbiFilterSystemsDesktop';
import { KonnectAnalytics } from 'KonnectAnalytics/konnectAnalytics';

export const SystemsFilterContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #c5d0de;
  width: 69px;
  height: 49px;
  margin-bottom: 4px;
  margin-right: 10px;
  cursor: pointer;
  @media (max-width: 750px) {
    margin-left: 0;
  }
`;

const PbiFilterSystems = React.memo((props: PbiFilterSystemsProps) => {
  const {
    filterState,
    filterData,
    isMachineFilterOpen,
    screenWidth,
    pbiReportHeight,
    toggleMachineFilterMenu,
  } = props;
  const { selectedSiteIds, selectedModelIds, selectedSystemSerials } = filterState;
  const currentSystems = filterData.systems.filter(system => !system.isHistorical);
  const selectedSystems = filterData.systems.filter(system =>
    selectedSystemSerials.includes(system.name)
  );
  // Default selection is all current printers without historical ones
  const isDefaultSelection =
    selectedSystems.length === currentSystems.length &&
    selectedSystems.every(system => !system.isHistorical);
  const filterNotEmpty = !!(
    (selectedSiteIds.length || selectedModelIds.length || selectedSystemSerials.length) &&
    !isDefaultSelection
  );

  const funnelColor = isMachineFilterOpen ? '#1878BA' : '#7F8FA4';

  const onFunnelClickHandler = (elementId = 'machine-filter-toggle-button') => {
    const nextState = isMachineFilterOpen ? 'closed' : 'opened';

    toggleMachineFilterMenu();
    KonnectAnalytics.toggleMachineFilterMenu({
      element_id: elementId,
      interaction_type: 'toggle',
      state: nextState,
    });
  };
  return (
    <>
      {screenWidth <= 1400 ? (
        <PbiFilterSystemsMobile
          pbiReportHeight={pbiReportHeight}
          filterNotEmpty={filterNotEmpty}
          funnelColor={funnelColor}
          isMachineFilterOpen={isMachineFilterOpen}
          {...props}
        />
      ) : (
        <PbiFilterSystemsDesktop
          pbiReportHeight={pbiReportHeight}
          filterNotEmpty={filterNotEmpty}
          funnelColor={funnelColor}
          onFunnelClickHandler={onFunnelClickHandler}
          {...props}
        />
      )}
    </>
  );
});

export default PbiFilterSystems;
